<template>
    <transition name="fade">
        <div v-if="isApplePaySupported" id="nspay-apple-pay" @click="processApplePayment">
            <div id="apple-pay-logo"></div>
        </div>
    </transition>
</template>
<script src="https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js"></script>
<script>
    import { mapGetters, mapState, mapMutations } from "vuex";
    import { sweetAlert2 } from "../../../mixins/sweet-alert2";
    import { showBlocker } from "../../../mixins/show-blocker";
    import { paymentMethods } from "../../../constants/payment-methods";
    import axios from "axios";
    import { appSettings } from "../../../mixins/app-settings";

    // This supports iOS 10 and macOS 10.12, latest is version 3 but support starts at iOS/macOS 13
    const supportedApplePayVersion = 1;

    export default {
        name: "ApplePay",
        mixins: [sweetAlert2, showBlocker, appSettings],
        data: function () {
            return {
                applePayInitialized: false
            }
        },
        computed: {
             ...mapState({
                appName: state => state.session.appName,
                siteId: state => state.session.siteId,
                accountId: state => state.session.accountId,
                checkId: state => state.session.checkId
            }),
            ...mapGetters([
                "balanceWithTip"
            ]),
            isApplePaySupported() {
                return window.ApplePaySession
                    && ApplePaySession.supportsVersion(supportedApplePayVersion)
                    && ApplePaySession.canMakePayments();
            },
        },
        methods:{
            ...mapMutations([
                "setLoadingStatus",
                "setPayment"
            ]),
            processApplePayment(){
                const paymentRequest = {
                    countryCode: 'US',
                    currencyCode: 'USD',
                    shippingMethods: [],
                    lineItems: [],
                    total:
                    {
                        label: this.appName,
                        type: 'final',
                        amount: this.balanceWithTip.toFixed(2).toString()
                    },
                    supportedNetworks:[ 'amex', 'discover', 'masterCard', 'visa'],
                    merchantCapabilities: [ 'supports3DS','supportsCredit', 'supportsDebit' ]
                };

                const session = new ApplePaySession(supportedApplePayVersion, paymentRequest);
                const vm = this;
                
                session.onvalidatemerchant = function(event){
                    const validationURL = event.validationURL;
                    
                    const getApplePaySessionRequest = {
                        validationUrl: validationURL,
                        accountId: vm.accountId,
                        siteId: vm.siteId
                    };
                    
                    axios.post(vm.getApiBaseUrl() + "/payeezy/getapplepaysession", getApplePaySessionRequest)
                        .then(response => {
                            session.completeMerchantValidation(response.data);
                        })
                        .catch(() => {
                            vm.swalError("1020");
                        });
                };

                session.onpaymentauthorized = function(event){
                    const payment = event.payment;
                    session.completePayment(ApplePaySession.STATUS_SUCCESS);
                    vm.sendPayloadToServer(payment.token.paymentData);
                }

                session.begin();
            },
            sendPayloadToServer(payment) {
                this.startProgressIndicator();

                let payload = {
                    SiteId: this.siteId,
                    AccountId: this.accountId,
                    CheckId: this.checkId,
                    PaymentAmount: this.balanceWithTip,
                    ApplePayPaymentData: window.btoa(JSON.stringify(payment))
                }

                axios.post(this.getApiBaseUrl() + "/payment/payment", payload)
                    .then(response => {
                        if (response.data) {
                            let payment = response.data;
                            payment.paymentName = paymentMethods.applePay;
                            this.setPayment(payment);
                            this.$router.push({ name: "PaymentSummary" });
                        }
                        else {
                            this.$router.push({ name: "Error", params: { errorCode: "1000" } });
                        }
                    })
                    .catch(error => {
                        if (error.response &&
                            error.response.data &&
                            error.response.data.errorCode) {
                            switch (error.response.data.errorCode) {
                                case "1008":
                                case "1009":
                                    this.$router.push({ name: "Error", params: { errorCode: error.response.data.errorCode } });
                                    break;
                                default:
                                    if (error.response.data.errorMessage) {
                                        console.error(error.response.data.errorMessage);
                                    }
                                    this.$router.push({ name: "Error", params: { errorCode: "1010" } });
                            }
                        }
                        else {
                            console.error(error);
                            this.$router.push({ name: "Error", params: { errorCode: "1010" } });
                        }
                    })
                    .finally(() => {
                        this.stopProgressIndicator();
                    });
            }
        }
    }
</script>